<template>
  <AppDialog
    :title="isEnabling ? 'Require SSO sign in?' : 'Remove SSO Requirement'"
    :show="showConfirmation"
    size="medium"
    append-to-body
    position="centered"
    @close="hideConfirmation"
  >
    <template
      v-if="isEnabling"
      #default
    >
      <p class="text-lighter">Are you sure you want to require SSO sign-in for your organization?</p>
      <div class="sso-disconnect-warning">
        <i class="fa fa-warning"></i>
        <ul class="mb-0 pl-20">
          <li>Requiring SSO login will enforce SSO for all members on your company domain. Members with non-domain emails can still log in with email and password.</li>
        </ul>
      </div>
    </template>
    <template
      v-else
      #default
    >
      <p class="text-lighter">Are you sure you want to remove required SSO log in? Are you sure you want to proceed?</p>
      <div class="sso-disconnect-danger">
        <i class="fa fa-warning"></i>
        <ul class="mb-0 pl-20">
          <li>Removing the SSO requirement will allow all members to log in with their Hubstaff email and password</li>
          <li>
            Two-factor authentication may no longer be enforced. Make sure it is enabled to keep your account secure.
            <a :href="mfaSettingsUrl" class="text-blue">
              Go to 2FA settings
            </a>
          </li>
        </ul>
      </div>
    </template>
    <template #footer>
      <div class="footer">
        <div class="buttons">
          <AppButton
            class="text-lighter"
            @click="hideConfirmation"
          >
            Cancel
          </AppButton>
          <AppButton
            v-if="isEnabling"
            type="primary"
            @click="confirmDisable"
          >
            Require SSO
          </AppButton>
          <AppButton
            v-else
            type="primary"
            @click="confirmDisable"
          >
            Remove
          </AppButton>
        </div>
      </div>
    </template>
  </AppDialog>
</template>

<script>
export default {
  name: 'SsoConfirm',
  props: {
    formId: { type: String, required: true },
    mfaSettingsUrl: { type: String, required: true },
    toggleId: { type: String, required: true },
  },
  data: () => ({
    form: null,
    isEnabling: false,
    showConfirmation: false,
    toggle: null,
  }),
  mounted() {
    this.toggle = document.getElementById(this.toggleId);
    this.form = document.getElementById(this.formId);

    if (!this.toggle || !this.form) {
      console.error(`Could not find toggle (${this.toggleId}) or form (${this.formId})`);

      return;
    }

    this.toggle.addEventListener('change', this.handleToggleChange, true);
  },
  beforeDestroy() {
    this.toggle?.removeEventListener('change', this.handleToggleChange, true);
  },
  methods: {
    handleToggleChange(event) {
      event.preventDefault();
      this.showConfirmation = true;
      this.isEnabling = this.toggle.checked;
      this.toggle.checked = !this.toggle.checked;
    },
    hideConfirmation() {
      this.showConfirmation = false;
    },
    confirmDisable() {
      this.toggle.checked = this.isEnabling;
      this.showConfirmation = false;
      this.form.submit();
    },
  },
};
</script>
